import React from "react";
import { useSelector } from "react-redux";
import Image from "react-bootstrap/Image";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import isEmpty from "../../../../../store/validation/is-Empty";

export const CuisineSetupHomeScreen = ({ onClick }) => {
  const editAction = useSelector((state) => {
    return !isEmpty(
      state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData
    )
      ? state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData
      : false;
  });
  return (
    <React.Fragment>
      <div>
        <div className="col-12 p-0 cuisine-setup-home-div">
          <h4>Cuisine Setup</h4>
          <Image
            src={require("../../../../../assets/images/onboarding/cusinesetup.png")}
            alt="Cuisine Setup"
            title="Cuisine Setup"
            fluid
          />
        </div>
        <div className="onboarding-map-setup-screen-autodetect-button mt-5">
          <ReusableOnboardingLink
            buttonTitle="Back Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            buttonText="Back"
            link={
              editAction
                ? "/admin_edit_healthAndsenitation"
                : "/addvendorhealthAndsenitation"
            }
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText="Next"
            buttonType="button"
            onClick={onClick}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
